import ComingSoon from './site/ComingSoon';
import { ROLE_GUEST } from './constants';

const theme = {
    routes: () => [
        {
            path: '/',
            component: ComingSoon,
            drop: true,
            role: ROLE_GUEST,
            props: {}
        },
        {
            path: '*',
            component: ComingSoon,
            drop: true,
            role: ROLE_GUEST,
            props: {}
        }
    ],
    menuTop: [],
    menuFooter: []
};

export default theme;
